<template>
	<div>
	<div  v-if="loading">Loading</div>
	<div v-else>
	<DataTable v-bind="{ fields, sortAliases, ...$attrs }" v-on="$listeners" @sorted.once="sorted">
		<template v-slot:[`cell(id)`]="{ value }">
			<div v-if="value" class="text-muted" :title="value">{{ value }}</div>
			<div v-else class="text-uppercase font-weight-bold text-danger">Missing</div>
		</template>
		<template v-if="renderCaseStatus" v-slot:[`cell(status)`]="{ value, item }" >
			<div v-if="value && item">
				<case-status-label :value="item" />

				<b-badge v-if="item.unable_to_complete" pill variant="warning" title="Unable To Complete">
					<font-awesome-icon icon="exclamation-triangle" />
				</b-badge>
			</div>
			<div v-else class="font-weight-bold text-uppercase text-danger">Missing</div>
		</template>

		<template v-slot:[`cell(case_type.name)`]="{ value }">
			<div v-if="value" class="w-10 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-uppercase font-weight-bold text-danger w-10">Missing</div>
		</template>

		<!-- <template v-slot:[`cell(client_employee.list_name)`]="{ value }">
			<div v-if="value" class="w-10 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-uppercase font-weight-bold text-danger">Missing</div>
		</template> -->

		<template v-slot:[`cell(patient.list_name)`]="{ value }">
			<div v-if="value" class="fix-patient text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-uppercase fix-patient font-weight-bold text-danger">Missing</div>
		</template>

		<template v-slot:[`cell(facility.name)`]="{ value }">
			<div v-if="value" class="fix-other text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted fix-other">&mdash;</div>
		</template>
		
		<template v-slot:[`cell(denial_types)`]="{ value }">
			<div  class="w-6 text-truncate" :title="displayDenialTypes(value)">{{ displayDenialTypes(value) }}</div>
			<!-- <div v-else class="text-muted">&mdash;</div> -->
		</template>

		<template v-slot:[`cell(appeals)`]="{ value }">
			<!-- <div v-if="value && value.length > 0" class="w-10 text-truncate">
				{{
					value
						.map((item) => {
							if (item.appeal_level && item.appeal_level.name) {
								return item.appeal_level.name;
							} else {
								return "(Missing Level)";
							}
						})
						.join(", ")
				}}
			</div>
			<div v-else class="text-muted">&mdash;</div> -->
			<div  class="w-6 text-truncate">
				{{  checkAppealLevelName(value) }}  
			</div>
		</template>

		<!-- <template v-slot:[`cell(disciplines)`]="{ value }">
			<div v-if="value && value.length > 0" class="w-10 text-truncate">
				{{
					value
						.map((item) => {
							if (item && item.short_name) {
								return item.short_name;
							} else {
								return "(Missing Name)";
							}
						})
						.join(", ")
				}}
			</div>
			<div v-else class="text-muted">&mdash;</div>
		</template> -->

		<template v-slot:[`cell(case_outcome.name)`]="{ value }">
			<div v-if="value" class="w-10 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted w-10">&mdash;</div>
		</template>

		<template v-slot:[`cell(insurance_provider.name)`]="{ value }">
			<div v-if="value" class="fix-patient text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted fix-patient">&mdash;</div>
		</template>

		<template v-slot:[`cell(insurance_provider_type.insurance_provider_type)`]="{ value }">
			<div v-if="value" class="w-8 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted w-8">&mdash;</div>
		</template>

		<template v-slot:[`cell(insurance_number)`]="{ value }">
			<div v-if="value" class="w-10 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted w-10">&mdash;</div>
		</template>

		<template v-slot:[`cell(admit_date)`]="{ value }">
			<div v-if="value" class="w-6 text-truncate" :title="value">{{ $filters.formatDate(value) }}</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(discharge_date)`]="{ value }">
			<div v-if="value" class="w-6 text-truncate" :title="value">{{ $filters.formatDate(value) }}</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(visit_number)`]="{ value }">
			<div v-if="value" class="w-10 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted w-10">&mdash;</div>
		</template>

		<template v-slot:[`cell(total_claim_amount)`]="{ value }">
			<div v-if="value && value > 0" class="w-6 text-truncate" :title="value">
				{{ $filters.currency(value) }}
			</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(disputed_amount)`]="{ value }">
			<div v-if="value && value > 0" class="w-6 text-truncate" :title="value">
				{{ $filters.currency(value) }}
			</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(total_claim_amount)`]="{ value }">
			<div v-if="value && value > 0" class="w-6 text-truncate" :title="value">
				{{ $filters.currency(value) }}
			</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(reimbursement_amount)`]="{ value }">
			<div v-if="value && value > 0" class="w-6 text-truncate" :title="value">
				{{ $filters.currency(value) }}
			</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(settled_amount)`]="{ value }">
			<div v-if="value && value > 0" class="w-6 text-truncate" :title="value">
				{{ $filters.currency(value) }}
			</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(assigned_to_user.full_name)`]="{ value }">
			<div v-if="value" class="w-10 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-primary w-10">Unassigned</div>
		</template>

		<template v-slot:[`cell(mrt_number)`]="{ value }">
			<div v-if="value" class="w-6 text-truncate" :title="value">{{ value }}</div>
			<div v-else class="text-muted w-6">&mdash;</div>
		</template>

		<template v-slot:[`cell(created)`]="{ value }">
			<div v-if="value" >{{ $filters.formatTimestamp(value) }}</div>
			<div v-else class="text-muted ">&mdash;</div>
		</template>
	</DataTable>
	</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import DataTable from "@/clients/components/Layout/data-table.vue";
import CaseStatusLabel from "@/clients/components/Cases/StatusLabel.vue";
import axios from "axios";

export default {
	name: "CaseTable",
	components: {
		CaseStatusLabel,
		DataTable,
	},
	props: {
		hideFacility: {
			type: Boolean,
			default: false,
		},
		hideInsuranceProvider: {
			type: Boolean,
			default: false,
		},
		hidePatient: {
			type: Boolean,
			default: false,
		},
		hideAssignedTo: {
			type: Boolean,
			default: false,
		},
		sort: {
			type: String,
			default: "created",
		},
		sortDescending: {
			type: Boolean,
			default: true,
		},
		renderCaseStatus:{
			type:Boolean,
			default:false,
		}
	},
	data() {
		return {
			loading: true,
      responseData: null,

		}

	},
	async created() {
    try {
      const response = await axios.get('/client/insuranceappeal');
      this.responseData = response.data;
	  
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.loading = false; // Set loading to false when the request is completed
    }
  },
	computed: {
		fields() {
			return [
			    {
					key: "id",
					label: "Case ID",
					sortable: true,
				},
				{
					key: "status",
					label: "Status",
					// sortKey: "status",
					sortable: true,
				},
				{
					key: "patient.list_name",
					sortKey: "Patients.last_name",
					label: "Patient",
					sortable: true,
					isRowHeader: true,
					class: this.hidePatient ? "d-none" : "",
				},
				{
					key: "facility.name",
					label: "Facility",
					sortable: true,
					class: this.hideFacility ? "d-none" : "",
				},
				{
					key: "assigned_to_user.full_name",
					sortKey: "AssignedToUser.last_name",
					label: "Assigned To",
					sortable: true,
					class: this.hideAssignedTo ? "d-none" : "",
				},
				{
					key: "denial_types",
					label: "Denial Type",
					sortable: true,
				},
				{
					key: "admit_date",
					label: "Begin DOS",
					sortable: true,
				},

				{
					key: "discharge_date",
					label: "End DOS",
					sortable: true,
				},
                
				{
					key: "appeals",
					sortKey: "AppealLevels.order_number",
					label: "Current Level",
					sortable: true,
				},
				// {
				// 	key: "disciplines",
				// 	label: "Disciplines",
				// 	sortable: false,
				// },
				
				//{
				//	key: "case_outcome.name",
				//	label: "Closure Reason",
				//	sortable: true,
				//},
				{
					key: "insurance_provider.name",
					label: "Insurance Provider",
					sortable: true,
					class: this.hideInsuranceProvider ? "d-none" : "",
				},
				{
					key: "insurance_provider_type.insurance_provider_type",
					label: "Ins. Prov. Type",
					sortable: true,
				},
				// {
				// 	key: "client_employee.list_name",
				// 	label: "Physician",
				// 	sortable: true,
				// 	isRowHeader: false,
				// },
				{
					key: "disputed_amount",
					label: "Initial Denial Amt",
					sortable: true,
				},
				{
					key: "total_claim_amount",
					label: "Total Claim Amt",
					sortable: true,
				},
				{
					key: "mrt_number",
					label: "MRT Number",
					sortable: true,
				},
				{
					key: "created",
					label: "Added",
				},
			];
		},
		...mapGetters({
			sortAliases: "cases/sortAliases",
		}),
	},
	// mounted() {
		
	// 	this.test();

		
	// },
	methods: {
		sorted(params) {
			this.$emit("update:sort", params.sort);
			this.$emit("update:sort-descending", params.sortDescending);
			this.$emit("sorted", params);
		},

		// async test(){
		// 	let name ="";
		// 	const url = "/client/insuranceappeal";
				
		// 		const response = await axios.get(url, {
		// 		headers: {
		// 			"Accept": "application/json",
		// 			// You can add other headers here if needed
		// 		},
		// 		});
		// 		console.log("Response =", response);
		// 		this.outgoingList = response.data;

		// 	console.log('Outputed =', this.value);

		// 	this.outgoingList.forEach((item, index)=> {
		// 		this.value.forEach((appealInfo , j )=>{
		// 			if(item.id == appealInfo.insurance_appeal_id){
		// 				console.log("Match Found =", item.label)
		// 				name += item.label + ", ";
		// 			}
		// 		});
		// 	});
		// 	this.generatedName = name
		// 	console.log("Name final =", this.generatedName);
		// },

		 checkAppealLevelName(value) {
			let maxId = -Infinity; // Initialize to a very small number
			let labelWithMaxId = ''; // Variable to store the label with the max id

			for (let i = 0; i < value.length; i++) {    
    		if (value[i].id > maxId) { // Check if the current ID is greater than maxId
        		maxId = value[i].id; // Update maxId with the current ID
				labelWithMaxId = '';
				if(value[i].is_rebill){
					labelWithMaxId = value[i].rebill_label;
				}
				else{
					labelWithMaxId = value[i].insurance_provider_appeal_level.label; // Update the label with the corresponding ID
				}
    		}
		}

		//console.log("Label with max ID:", labelWithMaxId);
		return labelWithMaxId; // Return the label with the max id

		},
		displayDenialTypes(value) {
			if (!Array.isArray(value) || value.length === 0) {
				return '';
			}
			// Extract unique names, sort them lexicographically, and join as a comma-separated string
			const uniqueNames = [...new Set(value.map(item => item.name || 'NO DATA'))].sort();
			return uniqueNames.join(', ');
		}
	},
};
</script>


<style scoped>
.fix-patient {
    width: 150px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.fix-other {
    width: 178px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}


</style>